module.exports = __webpack_public_path__ + "static/media/south-western_iberian_text_02.004b7955.jpg";